'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M515.080 128c-329.092 0-515.080 218.704-515.080 378.694 0 243.774 218.708 380.954 400.616 425.912 181.924 44.976 250.344-37.53 247.428-132.606-3.542-115.5 54.146-116.992 95.040-112.918 40.862 4.102 280.916 59.528 280.916-124.43 0-227.652-179.856-434.652-508.92-434.652zM448 192c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM160 576.492c-17.946 0-32.492-14.546-32.492-32.492s14.546-32.492 32.492-32.492 32.492 14.546 32.492 32.492-14.546 32.492-32.492 32.492zM256 448c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM512 704c-70.692 0-128-42.98-128-96s57.308-96 128-96c70.694 0 128 42.98 128 96s-57.306 96-128 96zM736 448c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z' })
    ));
};